import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import isarray from 'isarray';

var formatLabel = function formatLabel(label) {
  return label === 'owningUsers' ? 'owning users' : label === 'owningTeams' ? 'owning teams' : label;
};

var formatValue = function formatValue(value) {
  return value === null ? '' : isarray(value) ? value.map(formatValue).join(', ') : value.username || value.name || value;
};

var getToken = function getToken(tokens, name) {
  var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var result = tokens // find the token by the name
  .filter(function (token) {
    return token.name === name;
  }) // map to a copy of the token but omit the name property
  .map(function (_ref) {
    var name = _ref.name,
        rest = _objectWithoutProperties(_ref, ["name"]);

    return _objectSpread({}, rest);
  })[0];

  if (!result && required) {
    throw new Error("Could not find token named ".concat(name));
  } else {
    return result;
  }
};

var textToken = function textToken(value) {
  return {
    type: 'text',
    value: value
  };
};

export default (function (action, content) {
  var error;

  try {
    switch (action) {
      case 'Invitation Sent':
        {
          var invitationEmail = getToken(content, 'invitationEmail', false);
          return [invitationEmail ? textToken(invitationEmail.value) : getToken(content, 'user'), textToken('was invited by'), getToken(content, 'invitedBy')];
        }

      case 'Invitation Resent':
        {
          var _invitationEmail = getToken(content, 'invitationEmail', false);

          return [_invitationEmail ? textToken(_invitationEmail.value) : getToken(content, 'user'), textToken('had their invitation updated by'), getToken(content, 'invitedBy')];
        }

      case 'Invitation Removed':
        {
          var _invitationEmail2 = getToken(content, 'invitationEmail', false);

          return [_invitationEmail2 ? textToken(_invitationEmail2.value) : getToken(content, 'user'), textToken('had their invitation removed by'), getToken(content, 'removedBy')];
        }

      case 'Participant Created':
        return [getToken(content, 'user'), textToken('was added as a participant by'), getToken(content, 'createdBy')];

      case 'Participant Joined':
        {
          var user = getToken(content, 'user');
          var invitedBy = getToken(content, 'invitedBy', false);

          var _invitationEmail3 = getToken(content, 'invitationEmail', false);

          var joinedAsAdmin = getToken(content, 'joinedAsAdmin', false);
          var joinedAsOwner = getToken(content, 'joinedAsOwner', false);

          if (invitedBy && _invitationEmail3) {
            return [user, textToken('joined the discussion after'), invitedBy, textToken("sent an invitation to ".concat(_invitationEmail3.value))];
          } else if (invitedBy) {
            return [user, textToken('joined the discussion after being invited by'), invitedBy];
          } else if (joinedAsAdmin) {
            return [user, textToken('joined the discussion after being authorized as a space admin')];
          } else if (joinedAsOwner) {
            return [user, textToken('joined the discussion after being authorized as an owner')];
          } else {
            return [user, textToken('joined the discussion after being authorized by the join policy')];
          }
        }

      case 'Participant Left':
        return [getToken(content, 'user'), textToken('has left')];

      case 'Participant Removed':
        return [getToken(content, 'user'), textToken('has been removed by'), getToken(content, 'removedBy')];

      case 'Message Updated':
        return [getToken(content, 'updatedBy'), textToken('changed a message from'), getToken(content, 'previousMessage'), textToken('to'), getToken(content, 'message')];

      case 'Discussion Updated':
        var previous = JSON.parse(getToken(content, 'previousValues').value);
        var current = JSON.parse(getToken(content, 'values').value);
        return [getToken(content, 'updatedBy'), textToken('updated the discussion')].concat(_toConsumableArray(Object.entries(previous).map(function (_ref2, i) {
          var _ref3 = _slicedToArray(_ref2, 1),
              name = _ref3[0];

          var prefix = i > 0 ? ', and ' : '';
          var l = formatLabel(name);
          var p = formatValue(previous[name]);
          var c = formatValue(current[name]);
          return textToken("".concat(prefix).concat(l, " from [").concat(p, "] to [").concat(c, "]"));
        })));

      default:
        console.warn("Invalid system message action '".concat(action, "' - unable to generate content."));
    }
  } catch (e) {
    error = e;
  }

  console.error('Invalid system message', {
    action: action,
    content: content
  }, error);
  return [{
    type: 'text',
    value: 'Invalid system message'
  }];
});